import { Grid } from '@mui/material'
import { ReactNode } from 'react'

import useStyles from './styles'

interface IMobileBottomLayoutProps {
  children: ReactNode
  isFixed?: boolean
}

const MobileBottomLayout = ({ children, isFixed }: IMobileBottomLayoutProps) => {
  const classes = useStyles()

  return (
    <Grid
      container
      className={`${isFixed ? classes.wrapperFixed : classes.wrapperAbsolute} ${
        classes.bottomLayoutWrapper
      }`}
    >
      {children}
    </Grid>
  )
}

export { MobileBottomLayout }
